module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-BlackItalic.woff2?e78a230f3a3b6965a2e200f05bb55635";